// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_woc","cls2":"LoswpPackPitch-cls2_hyo LoswpPackPitch-cls1_woc"};